var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRunPlayer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5625 14.3337V3.66708C1.5625 2.78751 1.5625 2.34724 1.74759 2.087C1.90914 1.85986 2.15814 1.71074 2.43457 1.67508C2.75118 1.63425 3.13951 1.84135 3.91504 2.25497L13.915 7.5883L13.9187 7.58991C14.7757 8.04701 15.2045 8.27566 15.3451 8.58042C15.4678 8.84628 15.4678 9.15317 15.3451 9.41903C15.2043 9.72422 14.7745 9.9538 13.915 10.4122L3.91504 15.7455C3.13895 16.1594 2.7513 16.3657 2.43457 16.3249C2.15814 16.2892 1.90914 16.1401 1.74759 15.913C1.5625 15.6528 1.5625 15.2133 1.5625 14.3337Z",
    fill: "#13132C",
    stroke: "#13132C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunPlayer);
export default __webpack_public_path__ + "static/media/Run Player.ec9ecae8ecf66bcab2432ccfbb99344c.svg";
export { ForwardRef as ReactComponent };